import React from "react";
import Img from "./Img";
import ImgText from "./ImgText";
import ImgFullWidth from "./ImgFullWidth";
import ImgFullScreen from "./ImgFullScreen";

interface ImageProps {
  caption?: string;
  elementId?: string;
  fileUrl?: string;
  imgUrl?: string;
  url?: string;
  type?: string;
  cssClass?: string;
}

const Image: React.FC<ImageProps> = ({
  caption = "",
  elementId = "",
  fileUrl,
  imgUrl,
  url,
  type,
  cssClass,
}) => {
  const finalImgUrl = imgUrl || url;

  const captionArray =
    caption.indexOf("translation=") !== -1
      ? caption.split("translation=")
      : [caption];

  if (type && type.indexOf("standard") !== -1) {
    return (
      <>
        <Img
          cssClass={cssClass}
          elementId={elementId}
          url={finalImgUrl}
          type={type}
          fileUrl={fileUrl}
        />
        {caption !== "" ? (
          <p className="text-center mt_dec--20 mb--80">{caption}</p>
        ) : (
          ""
        )}
      </>
    );
  }

  if (type === "fullScreen") {
    return (
      <ImgFullScreen
        captionArray={captionArray}
        elementId={elementId}
        url={finalImgUrl}
      />
    );
  }

  if (type === "fullWidth") {
    return (
      <ImgFullWidth
        captionArray={captionArray}
        cssClass={cssClass}
        elementId={elementId}
        url={finalImgUrl}
      />
    );
  }

  if (type === "text") {
    return (
      <ImgText
        captionArray={captionArray}
        elementId={elementId}
        url={finalImgUrl}
      />
    );
  }

  return null;
};

export default Image;
